import React, { useEffect } from "react";
import { ZoomMtg } from "@zoomus/websdk";
import ZoomComponent from '../../components/Zoom/Zoom'

function Zoom(props) {
  return <ZoomComponent arenaData={props.arenaData} playerOption={true} />;
}

export default Zoom;
